import { DeviceTypeDto } from "./deviceTypeDto";
import {ProductClassificationDto} from "./ProductClassificationDto";

export class CreateAssetCommand {
    $type?: string = "Asset";
    cid?: string | null;
    typeDesignation?: string | null;
    installationId?: number | null;
    serialNumber?: string | null;
    quantity?: number | null;
    manufacturingDate?: Date | null;
    commissioningDate?: Date | null;
    isAccessibleForService?: string | null;
    description?: string | null;
    criticality?: string | null;
    registrationMountingLocation?: string | null;
    tagName?: string | null;
    deliveryDate?: Date | null;
    licenseNumber?: string | null;
    factoryWarrantyStart?: Date | null;
    factoryWarrantyEnd?: Date | null;
    customerWarrantyStart?: Date | null;
    customerWarrantyEnd?: Date | null;
    registrationInstallationStatusCode?: string | null;
    registrationInstallationStatusName?: string | null;
    valueInKusd?: number | null;
    registrationLatitude?: number | null;
    registrationLongitude?: number | null;
    lifeCyclePhase?: string | null;
    nextLifeCyclePhase?: string | null;
    nextLifeCyclePhaseDate?: Date | null;
    topAssetId?: number | null;
    parentSerialNumber?: string | null;
    parentAssetId?: string | null;
    topLevelSerialNumber?: string | null;
    salesOrder?: string | null;
    salesOrderItem?: string | null;
    extendedWarrantyStart?: Date | null;
    extendedWarrantyEnd?: Date | null;
    oldId?: number | null;
    materialCode?: string | null;
    isExternalVisible?: boolean | null;
    deviceType?: DeviceTypeDto | null;
    productClassification: ProductClassificationDto;

  constructor() {
    this.productClassification = {};
  }
}
